module.exports = __webpack_public_path__ + "static/media/background-head_blank-2.3d8a83bb.png";